import React, { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { RequireAuth } from '@components/RequireAuth'
import { AuthLayout } from '@components/layouts/AuthLayout'
import { MainLayout } from '@components/layouts/MainLayout'

import { Loader } from '@UI/Loader'

import { useActions } from '@hooks/useActions'

import { authRoutes, headerRoutes, routes } from './constants/routes'
import { Route as RouteType } from './types'

const renderRoutes = (routesArr: RouteType[], requireAuth: boolean) =>
  routesArr.map((i) => (
    <Route
      key={i.rootPath}
      path={i.rootPath}
    >
      {i.list.map((j) =>
        !!j?.list?.length ? (
          <Route
            key={j.path}
            path={j.path}
          >
            {j.list.map((k) => (
              <Route
                key={k.path}
                path={k.path}
                element={<Suspense fallback={<Loader />}>{requireAuth ? <RequireAuth>{k.element}</RequireAuth> : k.element}</Suspense>}
              />
            ))}
          </Route>
        ) : (
          <Route
            key={j.path}
            path={j.path}
            element={<Suspense fallback={<Loader />}>{requireAuth ? <RequireAuth>{j.element}</RequireAuth> : j.element}</Suspense>}
          />
        ),
      )}
    </Route>
  ))

export function App() {
  const { setAuth } = useActions()

  const token = localStorage.getItem('accessToken')

  if (token) {
    setAuth(true)
  }

  return (
    <Routes>
      <Route
        path={'/'}
        element={<MainLayout />}
      >
        {renderRoutes([...routes, ...headerRoutes], true)}
      </Route>

      <Route
        path={'/'}
        element={<AuthLayout />}
      >
        {renderRoutes(authRoutes, false)}
      </Route>

      <Route
        path="*"
        element={
          <Navigate
            to={'/catalog/products'}
            replace
          />
        }
      />
    </Routes>
  )
}
